import React from 'react';
import MyGallery from "../Gallery/MyGallery";
import './ServicesPage.css';
import { useTranslation } from "react-i18next";

function ReconstructionsPage() {
    const { t } = useTranslation();
    const directory= "/images/olikesAnakainiseis/";
    const filenames=[
        'VPR02331_Vasso_Paraschi.webp',
        'VPR02340_Vasso_Paraschi.webp',
        'VPR02364_Vasso_Paraschi.webp',
        'VPR02628_Vasso_Paraschi.webp',
        'VPR02639_Vasso_Paraschi.webp',
        'VPR02639_Vasso_Paraschi.webp',
        'VPR02951_Vasso_Paraschi.webp',
        'VPR02967_Vasso_Paraschi.webp',
        'VPR02972_Vasso_Paraschi.webp',
        'VPR03040_Vasso_Paraschi.webp',
        'VPR03221-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR03231-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR03267-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR03559-Enhanced-NR_Vasso_Paraschi.webp',
        'VPR03597-Enhanced-NR_Vasso_Paraschi.webp'
    ];

    return (
        <div className="services-page">
            <h1>{t("Complete Renovations")}</h1>
            <div className="services-info-container">
                <MyGallery directory={directory} filenames={filenames} />
            </div>
        </div>
    );
}

export default ReconstructionsPage;
